import { faCopy } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function CopyLinkButton({ onClick, name }) {
  return (
    <ColorChangingIcon
      icon={faCopy}
      name={name}
      initialPrimaryColor="#0078D4"
      padding="6px 10px 0 0"
      onClick={onClick}
    />
  );
}

export default CopyLinkButton;
